import CryptoJS from "crypto-js";

import { loadStripe } from "@stripe/stripe-js";

export const PROFESSIONAL_TYPE = {
  lender: "Lender",
  broker: "Broker",
  provider: "Provider",
  other: "Other",
};

export const PROVIDERS_TYPE = {
  attorney: "Attorney",
  title: "Title",
  escrow_Settlement: "Escrow/Settlement",
  otherServiceProvider: "Other Service Provider",
};

export const MAX_FILE_SIZE = 100;

export const ROLES = {
  admin: "Super Admin",
  subAdmin: "Admin",
  basicAccess: "Basic Access",
  marketingAdmin: "Marketing Admin",
  customer: "Customer",
  salesManager: "Sales Manager",
  representative: "Representative",
  assistant: "Assistant",
  brokerAdmin: "Broker Admin",
  titleAdmin: "Title Admin",
  agentSubAdmin: "Agent Sub Admin",
  AffiliateManager: "Affiliate Manager",
  professional: "Professional",
  serviceProvider: "Service Provider",
  secondaryUser: "Sub User",
  lennar: "Lennar",
  provider: "Provider",
  countyRecorder: "County Recorder",
};

/** Roles that can access the service provider portal (mirrors unified_auth.php). */
export const SERVICE_PROVIDER_PORTAL_ROLES = [
  ROLES.serviceProvider,
  "Title Company",
  "Escrow Company",
  "Lender Service Provider",
  "Real Estate Agent",
  "Notary",
  "Attorney",
  "Other Service Provider",
];

export const isServiceProviderPortalRole = (roleLabel) =>
  Boolean(roleLabel && SERVICE_PROVIDER_PORTAL_ROLES.includes(roleLabel));

export const ROLE_CODES = {
  admin: 1,
  subAdmin: 11,
  basicAccess: 12,
  marketingAdmin: 13,
  customer: 21,
  professional: 31,
  serviceProvider: 41,
  secondaryUser: 51,
  lennar: 61,
  provider: 71,
  countyRecorder: 81,
  AffiliateManager: 91,
};

export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

// is tailwind component
export const IS_TAILWIND_COMPONENT =
  process.env.REACT_APP_IS_TAILWIND_COMPONENT;

// record per page in admin tabels
export const PER_PAGE = 10;
export const MODAL_PAGE = 5;

export const resendOTPSeconds = 119;

export const UCC_FILLER_NAME = "EquityProtect Inc.";
export const UCC_FILLER_PHONE = "+18882132959";
export const UCC_FILLER_PHONE_FORMAT = "(888) 213-2959";
export const UCC_FILLER_EMAIL = "Recordings@equityprotect.com";
export const UCC_SECURED_PARTY_ORGANIZATION_NAME = "EquityProtect Inc.";
export const UCC_SECURED_PARTY_ADDRESS = "5566 Longley Ln Suite B";
export const UCC_SECURED_PARTY_CITY = "Reno";
export const UCC_SECURED_PARTY_STATE = "Nv";
export const UCC_SECURED_PARTY_POSTAL_CODE = "89511";

export const LOCAL_RECORDING_FEES = 125;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const FieldStyle = {
  borderRadius: "3px",
};

export const REQUEST_ACCESS_ACTION = [
  // { id: 1, label: "Waiver - Refinance", value: "waiver" },
  // { id: 2, label: "Termination - Sale", value: "termination" },
  { id: 3, label: "Title Unlock", value: "unlock authorization" },
  { id: 4, label: "Termination & waiver", value: "unlock package" },
  // { id: 5, label: "Restriction", value: "restriction" },
];

export const REQUESTED_DOCUMENT_STATUS = [
  { id: 1, label: "Requested", value: "requested" },
  { id: 2, label: "Accepted", value: "accepted" },
  // { id: 2, label: "Rejected", value: "rejected" },
  { id: 2, label: "Completed", value: "completed" },
  { id: 3, label: "Cancelled", value: "cancelled" },
  // { id: 3, label: "Restriction", value: "restriction" },
];

export const jsonLastStepOptions = [
  { value: "SEND_OTP", label: "SEND OTP" },
  { value: "VERIFY_PHONE_OTP", label: "VERIFY PHONE OTP" },
  { value: "VERIFY_EMAIL_OTP", label: "VERIFY EMAIL OTP" },
  { value: "GENERATE_QUESTIONS", label: "GENERATE QUESTIONS" },
  { value: "VERIFY_ANSWERS", label: "VERIFY ANSWERS" },
  { value: "GET_MAILING_ADDRESS", label: "GET MAILING ADDRESS" },
  { value: "SAVE_CREDIT_CARD", label: "SAVE CREDIT CARD" },
  { value: "PAYMENT", label: "PAYMENT" },
  { value: "SECURITY_PIN", label: "SECURITY PIN" },
  { value: "REGISTER_FACE", label: "REGISTER FACE" },
  { value: "REGISTER_SIGNATURE", label: "REGISTER SIGNATURE" },
  { value: "SAVE_BENEFICIARIES", label: "SAVE BENEFICIARIES" },
  { value: "SEND_WELCOME_EMAIL", label: "SEND WELCOME EMAIL" },
];

export const jsonLastSteps = {
  SEND_OTP: "SEND OTP",
  VERIFY_PHONE_OTP: "VERIFY PHONE OTP",
  VERIFY_EMAIL_OTP: "VERIFY EMAIL OTP",
  GENERATE_QUESTIONS: "GENERATE QUESTIONS",
  VERIFY_ANSWERS: "VERIFY ANSWERS",
  GET_MAILING_ADDRESS: "GET MAILING ADDRESS",
  SAVE_CREDIT_CARD: "SAVE CREDIT CARD",
  PAYMENT: "PAYMENT",
  SECURITY_PIN: "SECURITY PIN",
  REGISTER_FACE: "REGISTER FACE",
  REGISTER_SIGNATURE: "REGISTER SIGNATURE",
  SAVE_BENEFICIARIES: "SAVE BENEFICIARIES",
  SEND_WELCOME_EMAIL: "SEND WELCOME EMAIL",
};

// Subscription status labels the API gives a paid-at-closing property until
// EquityProtect marks its invoice paid (SubscriptionStatusResolver). The
// property status meanwhile reads Pending, with awaiting_closing_payment set.
export const CLOSING_PAYMENT_STATUS = {
  PENDING: "Pending – Due at Closing",
  PAYMENT_SENT: "Payment Sent – Awaiting Confirmation",
};

export const isClosingPaymentStatus = (status) =>
  status === CLOSING_PAYMENT_STATUS.PENDING ||
  status === CLOSING_PAYMENT_STATUS.PAYMENT_SENT;

export const SUBDOMAIN = {
  equityprotect: "equityprotect",
  servicer: "servicer",
  professional: "professional",
  try: "try",
  provider: "provider",
  car: "car",
};

/** Service-provider user type preset for the CAR partnership signup. */
export const CAR_REAL_ESTATE_AGENT_TYPE = "Real Estate Agent";

const currentHostname = () =>
  typeof window !== "undefined" ? window.location.hostname : "";

/** car.equityprotect.com, car-staging.*, car.localhost and other car-* hosts. */
export const isCarHost = (hostname = currentHostname()) => {
  const label = String(hostname || "").split(".")[0] || "";
  return label === SUBDOMAIN.car || label.startsWith(`${SUBDOMAIN.car}-`);
};

/** Partner channel stamped on service-provider signup. Empty off partner hosts. */
export const getSignupSourceForCurrentHost = (
  hostname = typeof window !== "undefined" ? window.location.hostname : "",
) => (isCarHost(hostname) ? SUBDOMAIN.car : "");

export const servicerProvidersjsonLastStepOptions = [
  { value: "SEND_OTP", label: "SEND OTP" },
  { value: "VERIFY_PHONE_OTP", label: "VERIFY PHONE OTP" },
  { value: "VERIFY_EMAIL_OTP", label: "VERIFY EMAIL OTP" },
  { value: "SAVE_PROFESSIONAL_DETAIL", label: "SAVE PROFESSIONAL DETAIL" },
  { value: "REGISTER_FACE", label: "REGISTER FACE" },
  { value: "REGISTER_SIGNATURE", label: "REGISTER SIGNATURE" },
  { value: "SEND_WELCOME_EMAIL", label: "SEND WELCOME EMAIL" },
];

export const CALENDLY_MEET_URL = "https://calendly.com/jon-ep2018/30min";
// https://calendly.com/ashish-thakor-crest/lead

export const playStoreURL = "https://play.google.com/store/apps";
export const appStoreURL =
  "https://apps.apple.com/es/app/equityprotect/id6446863228";

// to sort the states
// console.log(
//   "sorted array",
//   USA_STATES.sort((state1, state2) => state1.code.localeCompare(state2.code))
// );

// states of the USA
export const USA_STATES = [
  { name: "Alaska", code: "AK" },
  { name: "Alabama", code: "AL" },
  { name: "Arkansas", code: "AR" },
  { name: "Arizona", code: "AZ" },
  { name: "California", code: "CA" },
  { name: "Colorado", code: "CO" },
  { name: "Connecticut", code: "CT" },
  { name: "Delaware", code: "DE" },
  { name: "District of Columbia", code: "DC" },
  { name: "Florida", code: "FL" },
  { name: "Georgia", code: "GA" },
  { name: "Hawaii", code: "HI" },
  { name: "Iowa", code: "IA" },
  { name: "Idaho", code: "ID" },
  { name: "Illinois", code: "IL" },
  { name: "Indiana", code: "IN" },
  { name: "Kansas", code: "KS" },
  { name: "Kentucky", code: "KY" },
  { name: "Louisiana", code: "LA" },
  { name: "Massachusetts", code: "MA" },
  { name: "Maryland", code: "MD" },
  { name: "Maine", code: "ME" },
  { name: "Michigan", code: "MI" },
  { name: "Minnesota", code: "MN" },
  { name: "Missouri", code: "MO" },
  { name: "Mississippi", code: "MS" },
  { name: "Montana", code: "MT" },
  { name: "North Carolina", code: "NC" },
  { name: "North Dakota", code: "ND" },
  { name: "Nebraska", code: "NE" },
  { name: "New Hampshire", code: "NH" },
  { name: "New Jersey", code: "NJ" },
  { name: "New Mexico", code: "NM" },
  { name: "Nevada", code: "NV" },
  { name: "New York", code: "NY" },
  { name: "Ohio", code: "OH" },
  { name: "Oklahoma", code: "OK" },
  { name: "Oregon", code: "OR" },
  { name: "Pennsylvania", code: "PA" },
  { name: "Rhode Island", code: "RI" },
  { name: "South Carolina", code: "SC" },
  { name: "South Dakota", code: "SD" },
  { name: "Tennessee", code: "TN" },
  { name: "Texas", code: "TX" },
  { name: "Utah", code: "UT" },
  { name: "Virginia", code: "VA" },
  { name: "Vermont", code: "VT" },
  { name: "Washington", code: "WA" },
  { name: "Wisconsin", code: "WI" },
  { name: "West Virginia", code: "WV" },
  { name: "Wyoming", code: "WY" },
];

export const AddressVerificationColumns = [
  {
    id: "no",
    disablePadding: true,
    label: "No.",
  },
  {
    id: "mailingaddress",
    disablePadding: true,
    label: "Property Address",
  },
  {
    id: "postcard",
    disablePadding: true,
    label: "Verify Postcard",
  },
  {
    id: "status",
    disablePadding: true,
    label: "Status",
  },
];

// provider type like lennar/acpc etc.
export const PROVIDERSTYPE = {
  lennar: "lennar",
  acpc: "acpc",
};

// ====================ENV====================

// country code
export const COUNTRY_CODE = process.env.REACT_APP_COUNTRY_CODE;

// google map API key
const resolveGoogleApiKey = () => {
  const localDevKey = process.env.REACT_APP_SERVICER_LOCAL_GOOGLE_API_KEY;
  if (typeof window !== "undefined" && localDevKey) {
    const hostname = window.location.hostname;
    if (
      hostname === "localhost" ||
      hostname === "127.0.0.1" ||
      hostname === "servicer.localhost" ||
      hostname.endsWith(".servicer.localhost")
    ) {
      return localDevKey;
    }
  }

  return process.env.REACT_APP_GOOGLE_API_KEY || "";
};

export const GOOGLE_API_KEY = resolveGoogleApiKey();

// support information
export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL;
export const SUPPORT_PHONE = process.env.REACT_APP_SUPPORT_PHONE;
export const SUPPORT_PHONE_FORMAT = process.env.REACT_APP_SUPPORT_PHONE_FORMAT;
export const EP_ADDRESS = process.env.REACT_APP_EP_ADDRESS;
export const ATTORNEY_SUPPORT_PHONE =
  process.env.REACT_APP_ATTORNEY_SUPPORT_PHONE;
export const ATTORNEY_SUPPORT_PHONE_FORMAT =
  process.env.REACT_APP_ATTORNEY_SUPPORT_PHONE_FORMAT;
export const BLOG_SUPPORT_PHONE = process.env.REACT_APP_BLOG_SUPPORT_PHONE;
export const BLOG_SUPPORT_PHONE_FORMAT =
  process.env.REACT_APP_BLOG_SUPPORT_PHONE_FORMAT;
export const PROPERTY_RISK_SUPPORT_PHONE =
  process.env.REACT_APP_PROPERTY_RISK_SUPPORT_PHONE;
export const PROPERTY_RISK_SUPPORT_PHONE_FORMAT =
  process.env.REACT_APP_PROPERTY_RISK_SUPPORT_PHONE_FORMAT;

// base url: BE local/staging/production
const resolveBaseUrl = () => {
  const fromEnv = process.env.REACT_APP_API_URL?.trim();
  if (fromEnv) {
    return fromEnv.endsWith("/") ? fromEnv : `${fromEnv}/`;
  }

  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return "http://127.0.0.1:8000/api/v1/";
    }
  }

  return undefined;
};

export const BASE_URL = resolveBaseUrl();

// base url:serivce provider
export const SERVICE_PROVIDERS_URL =
  process.env.REACT_APP_SERVICE_PROVIDERS_URL;

export const RYAN_STAGING_HOST = "ryan-staging.equityprotect.com";
export const RYAN_STAGING_SERVICER_HOST =
  "servicer-ryan-staging.equityprotect.com";

export const isRyanStagingHost = (
  hostname = typeof window !== "undefined" ? window.location.hostname : "",
) => /(^|\.)ryan-staging\.equityprotect\.com$/i.test(hostname);

export const isRyanStagingServicerHost = (
  hostname = typeof window !== "undefined" ? window.location.hostname : "",
) => /(^|\.)servicer-ryan-staging\.equityprotect\.com$/i.test(hostname);

export const isServiceProviderPortalHost = (
  hostname = typeof window !== "undefined" ? window.location.hostname : "",
) =>
  isRyanStagingServicerHost(hostname) ||
  hostname.split(".")[0]?.includes("servicer");

export const isRyanStagingBuild = () =>
  String(process.env.REACT_APP_DEFAULT_URL || "").includes(
    "ryan-staging.equityprotect.com",
  );

export const getServiceProvidersUrl = () => {
  if (typeof window !== "undefined" && isServicerLocalDevHost()) {
    return `${window.location.origin}/`;
  }

  if (typeof window !== "undefined" && isLocalDevHost()) {
    const port = window.location.port ? `:${window.location.port}` : "";
    return `http://servicer.localhost${port}/`;
  }

  if (typeof window !== "undefined" && isRyanStagingServicerHost()) {
    return `https://${RYAN_STAGING_SERVICER_HOST}/`;
  }

  if (
    typeof window !== "undefined" &&
    SERVER === "staging" &&
    (isRyanStagingHost() || isRyanStagingServicerHost())
  ) {
    return `https://${RYAN_STAGING_SERVICER_HOST}/`;
  }

  const fromEnv = process.env.REACT_APP_SERVICE_PROVIDERS_URL?.trim();
  if (fromEnv) {
    return fromEnv.endsWith("/") ? fromEnv : `${fromEnv}/`;
  }

  if (SERVER === "production") {
    return "https://servicer.equityprotect.com/";
  }

  if (SERVER === "staging") {
    return "https://servicer-staging.equityprotect.com/";
  }

  return "http://servicer.localhost:3000/";
};

/** CAR partnership site. REACT_APP_CAR_URL wins; otherwise the default for REACT_APP_SERVER. */
export const getCarUrl = ({
  envUrl = process.env.REACT_APP_CAR_URL,
  server = SERVER,
} = {}) => {
  const fromEnv = envUrl?.trim();
  if (fromEnv) {
    return fromEnv.endsWith("/") ? fromEnv : `${fromEnv}/`;
  }

  if (server === "production") {
    return "https://car.equityprotect.com/";
  }

  if (server === "staging") {
    return "https://car-staging.equityprotect.com/";
  }

  return "http://car.localhost:3000/";
};

export const getCustomerStagingUrl = () => {
  if (
    typeof window !== "undefined" &&
    (isRyanStagingHost() || isRyanStagingServicerHost())
  ) {
    return `https://${RYAN_STAGING_HOST}/`;
  }

  return "https://staging.equityprotect.com/";
};

// base url:other 3rd party provider
export const OTHER_PROVIDERS_URL = process.env.REACT_APP_OTHER_PROVIDERS_URL;

// base url:custom domain url for provider
export const CUSTOM_DOMAIN_URL = process.env.REACT_APP_CUSTOM_DOMAIN_URL;

// Server IP
export const SERVER_IP = process.env.REACT_APP_SERVER_IP;

// FE local/staging/production
export const isLocalDevHost = (
  hostname = typeof window !== "undefined" ? window.location.hostname : "",
) => hostname === "localhost" || hostname === "127.0.0.1";

export const isServicerLocalDevHost = (
  hostname = typeof window !== "undefined" ? window.location.hostname : "",
) => hostname.split(".")[0]?.includes("servicer") ?? false;

/** Local servicer portal only — not staging/production servicer hosts. */
export const isLocalServicerPortalHost = (
  hostname = typeof window !== "undefined" ? window.location.hostname : "",
) =>
  hostname === "servicer.localhost" || hostname.endsWith(".servicer.localhost");

export const shouldDisableServicerAddressAutocomplete = () => {
  if (!isLocalServicerPortalHost()) {
    return false;
  }

  return (
    process.env.REACT_APP_DISABLE_SERVICER_ADDRESS_AUTOCOMPLETE !== "false"
  );
};

export const shouldLoadGoogleMapsScript = () => {
  if (typeof window === "undefined") {
    return true;
  }

  // Local dev pages load Places via react-google-autocomplete (apiKey prop).
  // Loading here too causes duplicate Maps scripts and broken autocomplete UI.
  if (isLocalDevHost() || isLocalServicerPortalHost()) {
    return false;
  }

  return !shouldDisableServicerAddressAutocomplete();
};

export const getDefaultUrl = () => {
  if (typeof window !== "undefined" && isLocalDevHost()) {
    return `${window.location.origin}/`;
  }
  return process.env.REACT_APP_DEFAULT_URL || "";
};

/** Resolves to current origin on localhost; env URL elsewhere (via toString in templates). */
export const DEFAULT_URL = {
  toString: () => getDefaultUrl(),
  valueOf: () => getDefaultUrl(),
  [Symbol.toPrimitive]: () => getDefaultUrl(),
};

/**
 * EquityProtect Service Agreement accepted at C.A.R. sign-up and authorization
 * steps (card 3853). Empty until the document is published; the name then
 * shows without a link.
 */
export const SERVICE_AGREEMENT_URL = process.env.REACT_APP_SERVICE_AGREEMENT_URL || "";

/** Default landing route for logged-in customers after login. */
export const CUSTOMER_HOME_PATH = "/properties";

// try domin
export const TRY_DOMAIN_URL = process.env.REACT_APP_TRY_DOMAIN_URL;

// try domin
export const COUNTY_URL = process.env.REACT_APP_COUNTY_URL;

// local || staging || production
export const SERVER = process.env.REACT_APP_SERVER;

// stripe key
export const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY;
export const stripePromise = loadStripe(STRIPE_KEY);

// recaptcha site key
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export const shouldBypassRecaptcha = () => {
  if (typeof window !== "undefined") {
    if (
      isRyanStagingHost(window.location.hostname) ||
      isRyanStagingServicerHost(window.location.hostname)
    ) {
      return true;
    }
  }

  if (isRyanStagingBuild()) {
    return true;
  }

  if (SERVER !== "production") {
    return true;
  }

  return false;
};

//for encryption and decryption
export const secretKey = CryptoJS.enc.Hex.parse(
  process.env.REACT_APP_ENCRYPTION_SECRET_KEY,
); // 128-bit key;

export const secretKeyEncrypt = process.env.REACT_APP_ENCRYPTION_SECRET_KEY;

// Initialization Vector value
export const iv = CryptoJS.enc.Hex.parse(
  process.env.REACT_APP_ENCRYPTION_VECTOR_KEY,
); // Random 128-bit IV

// pusher credentials
export const BACKEND_URL = process.env.REACT_APP_API_URL;
export const PUSHER_APP_KEY = process.env.REACT_APP_PUSHER_APP_KEY;
export const PUSHER_APP_CLUSTER = process.env.REACT_APP_PUSHER_APP_CLUSTER;

// social media links
export const INSTAGRAM_LINK = process.env.REACT_APP_INSTAGRAM_LINK;
export const FACEBOOK_LINK = process.env.REACT_APP_FACEBOOK_LINK;
export const LINKEDIN_LINK = process.env.REACT_APP_LINKEDIN_LINK;
export const YOUTUBE_LINK = process.env.REACT_APP_YOUTUBE_LINK;

// Better Business Bureau links
export const BBB_REVIEW_LINK = process.env.REACT_APP_BBB_REVIEW_LINK;

//Agent's Signup terms and conditions
export const AGENTS_TERMS_LINK = process.env.REACT_APP_AGENTS_TERMS_LINK;

// Marketing Lead Gen ID for Signup form
export const SIGNUP_MARKETING_AUTOMATION_ID =
  process.env.REACT_APP_SIGNUP_MARKETING_AUTOMATION_ID;

// Marketing Lead Gen ID for Property Risk form
export const MARKETING_AUTOMATION_ID =
  process.env.REACT_APP_MARKETING_AUTOMATION_ID;
export const MIKE_MARKETING_AUTOMATION_ID =
  process.env.REACT_APP_MARKETING_MIKE_AUTOMATION_ID;
export const GORKA_MARKETING_AUTOMATION_ID =
  process.env.REACT_APP_MARKETING_GORKA_AUTOMATION_ID;
export const PRAGER_MARKETING_AUTOMATION_ID =
  process.env.REACT_APP_MARKETING_PRAGER_AUTOMATION_ID;

//National Hosts Promocode
export const Mike30 = process.env.REACT_APP_RADIO_Mike30;
export const Gorka30 = process.env.REACT_APP_RADIO_Gorka30;
export const Prager30 = process.env.REACT_APP_RADIO_Prager30;
export const BentonCountyPromocode = process.env.REACT_APP_COUNTY_BENTON;
export const CarrollCountyPromocode = process.env.REACT_APP_COUNTY_CARROLL;
export const DickensonCountyPromocode = process.env.REACT_APP_COUNTY_DICKENSON;
export const ShelbyCountyPromocode = process.env.REACT_APP_COUNTY_SHELBY;
export const VacantlandPromocode = process.env.REACT_APP_COUNTY_VACANTLAND;
export const KosciuskoCountyPromocode = process.env.REACT_APP_COUNTY_KOSCIUSKO;
export const ElDoradoCountyPromocode = process.env.REACT_APP_COUNTY_ELDORADO;
export const SteubenCountyPromocode = process.env.REACT_APP_COUNTY_STEUBEN;
export const BaymiCountyPromocode = process.env.REACT_APP_COUNTY_BAYMI;
export const JenningsCountyPromocode = process.env.REACT_APP_COUNTY_JENNINGS;
export const MadisonCountyPromocode = process.env.REACT_APP_COUNTY_MADISON;
export const GastonCountyPromocode = process.env.REACT_APP_COUNTY_GASTON;
export const BartholomewCountyPromocode =
  process.env.REACT_APP_COUNTY_BARTHOLOMEW;
export const BellLandTitlePromocode =
  process.env.REACT_APP_BELL_LAND_TITLE_PROMOCODE;

// allowed email address for export Payment CSV
export const danEmail = process.env.REACT_APP_DAN_EP;
export const thyEpEmail = process.env.REACT_APP_THY_EP;

// allowed email address for Generate/Upload UCC
export const uccAdmin = process.env.REACT_APP_UCC_ADMIN;

// allowed email address for admin access for postcard token
export const adminAccessForPostcardToken =
  process.env.REACT_APP_ADMIN_ACCESS_FOR_POSTCARD_TOKEN;

// EP Subscription saving values
export const PER_MONTH_SAVINGS = process.env.REACT_APP_PER_MONTH_SAVINGS;
export const PER_ANNUAL_SAVINGS = process.env.REACT_APP_PER_ANNUAL_SAVINGS;

// To find the time zone of the user's browser
export const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

// County Account Vertical for County Branding
export const CountyVertical = [
  {
    county_name: "Benton",
    county_code: "bentoncountyin",
    county_code1: "bentonin",
    promoCode: BentonCountyPromocode, //for static promocode for this county
  },
  {
    county_name: "Carroll",
    county_code: "carrollcountyin",
    county_code1: "carrollin",
    promoCode: CarrollCountyPromocode, //for static promocode for this county
  },
  {
    county_name: "Shelby",
    county_code: "shelbycountyin",
    county_code1: "shelbyin",
    promoCode: ShelbyCountyPromocode, //for static promocode for this county
  },
  {
    county_name: "San Luis Obispo",
    county_code: "vacantland",
    county_code1: "vacantland",
    promoCode: VacantlandPromocode, //for static promocode for this county
  },
  {
    county_name: "Adams",
    county_code: "adamscountyin",
    county_code1: "adamsin",
  },
  {
    county_name: "Dickenson",
    county_code: "dickensoncountyva",
    county_code1: "dickensonva",
    allowFindRiskScore: true,
    promoCode: DickensonCountyPromocode, //for static promocode for this county
  },
  {
    county_name: "Kosciusko",
    county_code: "kosciuskocountyin",
    county_code1: "kosciuskoin",
    promoCode: KosciuskoCountyPromocode, //for static promocode for this county
  },
  {
    county_name: "El Dorado",
    county_code: "eldocountyca",
    county_code1: "eldocountyca",
    promoCode: ElDoradoCountyPromocode, //for static promocode for this county
    setupFeeCredit: 50, // one-time credit shown to residents; other counties show 85
  },
  {
    county_name: "Steuben",
    county_code: "steubenin",
    county_code1: "steubenin",
    promoCode: SteubenCountyPromocode, //for static promocode for this county
  },
  {
    county_name: "Bay",
    county_code: "baycountymi",
    county_code1: "baycountymi",
    promoCode: BaymiCountyPromocode, //for static promocode for this county
  },
  {
    county_name: "Jennings",
    county_code: "jenningscountyin",
    county_code1: "jenningsin",
    promoCode: JenningsCountyPromocode, //for static promocode for this county
  },
  {
    county_name: "Madison",
    county_code: "madisoncountyny",
    county_code1: "madisonny",
    promoCode: MadisonCountyPromocode, //for static promocode for this county
  },
  {
    county_name: "Gaston",
    county_code: "gastoncountync",
    county_code1: "gastonnc",
    promoCode: GastonCountyPromocode, //for static promocode for this county
    setupFeeCredit: 50, // one-time credit shown to residents; other counties show 85
    allowFindRiskScore: true, // "Do Not have a Token" signup for owners without a letter
    // Token-less owners get the El Dorado-style free Enhanced Monitoring signup.
    freeMonitoringSite: "gaston_site",
    acknowledgeMsg: (
      <span className="text-xs text-gray-500 text-start">
        I acknowledge that I am signing up for Free Property Monitoring and
        consent to receive communications and updates regarding my property.
      </span>
    ),
  },
  {
    county_name: "Bartholomew",
    county_code: "bartholomewcountyin",
    county_code1: "bartholomewin",
    promoCode: BartholomewCountyPromocode, //for static promocode for this county
    setupFeeCredit: 50, // one-time credit shown to residents; other counties show 85
    // "Do Not have a Token" free site comes from the backend (county/details free_site).
  },
];

// Define allowed prefixes for common routes in navbar
export const ALLOWED_PREFIXES = [
  {
    // for insurance companies including agents with the prefix /insurance to access public pages
    prefix: "insurance",
    name: "Insurance",
    dynamic_companyName: true, //ex:The Premium Select Group
    url_prefix: true,
    source: "insurance",
    hideformSourceFilter: true, // to hide the source filter
  },
  // for Househappy company, does not have agents, without the prefix /title or /broker, and does not include agents
  {
    prefix: "househappy",
    user_type: "househappy",
    name: "Househappy",
    dynamic_companyName: false,
    url_prefix: false,
    source: null,
    hideformSourceFilter: true, // to hide the source filter
  },
  // for title companies, including agents, without the prefix /title or /broker
  {
    prefix: "belllandtitle",
    dynamic_companyName: false,
    companyName: "BellLandTitle",
    url_prefix: true,
    source: "title",
    promoCode: BellLandTitlePromocode, //for static promocode for this title company
    isFirstYearFreePricing: true, // for display first year free pricing
  },
  {
    prefix: "oasistitle",
    dynamic_companyName: false,
    companyName: "OasisTitle",
    url_prefix: true,
    source: "title",
    promoCode: BellLandTitlePromocode, //for static promocode for this title company
    isFirstYearFreePricing: true, //for display first year free pricing
  },
  {
    prefix: "peertitle",
    dynamic_companyName: false,
    companyName: "PeerTitle",
    url_prefix: true,
    source: "title",
    promoCode: BellLandTitlePromocode, //for static promocode for this title company
    isFirstYearFreePricing: true, //for display first year free pricing
  },
  {
    prefix: "globalpartnerssettlement",
    dynamic_companyName: false,
    companyName: "GlobalPartnersSettlement",
    url_prefix: true,
    source: "title",
    promoCode: BellLandTitlePromocode, //for static promocode for this title company
    isFirstYearFreePricing: true, //for display first year free pricing
  },
];

/** Base Tailwind class for modal/primary buttons (size, shape, transition) */
export const TAILWIND_BUTTON_BASE_CLASS =
  "font-medium px-10 py-3 text-base rounded-full shadow-md hover:shadow-lg transition-all";

/** Compact success button with ring (py-2.5, text-sm, ring) – use for inline/alert actions */
export const TAILWIND_SUCCESS_BUTTON_RING_CLASS =
  "font-medium px-10 py-2.5 text-uppercase text-sm rounded-full shadow-md transition-all bg-secondary bg-gradient-to-r from-secondary to-cyan-400 hover:from-secondary/90 hover:to-cyan-400/90 text-white hover:shadow-lg ring-2 ring-secondary/30 ring-offset-2";

/** Gradient submit button (forces gradient even with type="submit") */
export const TAILWIND_GRADIENT_SUBMIT_BUTTON_CLASS =
  "tw_submit_button bg-gradient-to-r from-secondary to-cyan-400 hover:from-secondary/90 hover:to-cyan-400/90 text-white font-medium px-8 py-2.5 text-sm rounded-full mb-6 shadow-md hover:shadow-lg transition-all";

// example for search property address format
export const SEARCH_PROPERTY_ADDRESS_FORMAT =
  process.env.REACT_APP_SEARCH_PROPERTY_ADDRESS_FORMAT ||
  "Enter your property address";

/** User-facing label for protected-party redaction (Daniels Law). */
export const DANIELS_LAW_DISPLAY_NAME =
  process.env.REACT_APP_DANIELS_LAW_DISPLAY_NAME || "Daniels Law";
